import { useEffect, useRef, useState } from 'react';
import { InteractionConfig } from './types';

export default function Interaction(props: {
	shouldPlay: boolean;
	config: InteractionConfig;
	onLoaded: () => void;
	onDone: () => void;
	onError: (e: Error) => void;
}) {

	const [hovering, setHovering] = useState(false)
	const [imgPath, setImgPath] = useState("")
	const [gone, setGone] = useState(false)
	const ttsRef = useRef<HTMLAudioElement>(null)

	useEffect(() => {
		const prob = Math.random()
		if (prob < 0.05) {
			setImgPath("/shiny-card.png")
		} else if (prob < 0.1) {
			setImgPath("/legendary-card.png")
		} else if (prob < 0.4) {
			setImgPath("/rare-card.png")
		} else if (prob < 0.6) {
			setImgPath("/uncommon-card.png")
		} else {
			setImgPath("/common-card.png")
		}
		setTimeout(() => {
			if (!ttsRef.current) {
				return
			}
			ttsRef.current.play()
		}, 5500)
	}, [])

	// call after preloading is done
	props.onLoaded();
	// call onDone when your interaction is done or after some timeout
	setTimeout(() => {
		props.onDone();
	}, props.config.preRotateMS! + props.config.postRotateMS! + 800);

	if (props.shouldPlay) {

	}

	setTimeout(() => {
		setHovering(true)
	}, props.config.preRotateMS!)

	setTimeout(() => {
		setGone(true)
	}, props.config.preRotateMS! + props.config.postRotateMS!)

	// TODO here comes your own code
	return (
		<div className={`flip-card ${gone ? 'gone' : ''}`}>
			<audio src={'/whosthatpokemon.mp3'} autoPlay={true} />
			<audio ref={ttsRef} src={props.config.TTSNarrationURL} autoPlay={false} />
			<div className={`flip-card-inner ${hovering ? 'hovering' : ''}`}>
				<div className="flip-card-front">
					<img style={{
						width: '432px',
						height: '600px'
					}} src='/tangiamon-back.png' alt="Avatar"/>
				</div>
				<div className="flip-card-back rounded-3xl">
					<img style={{
						width: '432px',
						height: '600px',
						zIndex: -1
					}} className="absolute" src={imgPath} alt="Avatar"/>
					<div style={{
						background: `url(${props.config.picSrc})`,
						backgroundSize: 'contain',
						height: '344px',
						width: '344px',
						top: '95px',
						left: '44px',
						borderRadius: '10px'
					}} className="absolute" />
					<p className='absolute text-white font-medium' style={{
						top: '540px',
						left: '50px'
					}}>@{props.config.sender}</p>
					<p className='absolute text-white text-[20px] leading-[22px] font-medium text-ellipsis overflow-hidden' style={{
						top: '460px',
						left: '50px',
						width: '350px',
						height: '70px',
						textAlign: 'left'
					}}>{props.config.prompt}</p>
					<p className='absolute text-white text-ellipsis overflow-hidden font-semibold text-3xl' style={{
						top: '45px',
						left: '40px',
						width: '350px',
						textAlign: 'left'
					}}>{props.config.name}</p>
				</div>
			</div>
		</div>
	);
}
